//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["property"],
  data: function data() {
    return {
      selectedAmenities: [],
      amenities: [],
      unitTypes: [],
      unit: {},
      loading: false,
      buildings: [],
      building: "",
      selectedStatus: '',
      verified_by: '',
      move_in_date_display: false,
      unitType: "",
      unitStatus: ['Rented', 'Model', 'Down', 'Vacant - Not Leased', 'Vacant - Leased', 'NTV - Available', 'NTV - Leased', 'Shop', 'Rehab'],
      statuses: [],
      users: [],
      unitMeasurements: ["Studio", "1", "2", "3", "4"],
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var $el = this;

    //this.getDropDownOptions();

    axios.post("/prototype/units/options", { property: this.property }).then(function (response) {
      //if (response.data) {
      $el.amenities = response.data.amenities;
      $el.unitTypesRaw = response.data.unitTypes;
      if (response.data.buildings.length) {
        $el.buildings = response.data.buildings;
      }
      $el.statuses = response.data.statuses;
      var payLoad = [];
      $el.unitTypesRaw.map(function (unitTypesR) {
        if (unitTypesR.name) {
          payLoad.push({ "id": unitTypesR.id, "name": unitTypesR.name });
        }
      });
      $el.unitTypes = payLoad;
      $el.loading = false;
      //}
    });

    axios.get("/prototype/units/get-verified-list").then(function (response) {
      $el.usersRaw = response.data;
      var payLoadUser = [];
      $el.usersRaw.map(function (usersR) {
        payLoadUser.push({ "id": usersR.id, "name": usersR.first_name + ' ' + usersR.last_name });
      });
      $el.users = payLoadUser;
    });

    Event.$on("add-unit", function (item) {
      $el.$children[0].$data.showModal = true;
      _this.selectedAmenities = [];

      //$el.loading = false;
      _this.unit.building_id = item.item;
    });
  },


  computed: {
    filteredAmenities: function filteredAmenities() {
      var $el = this;
      return $el.amenities.filter(function (amen) {
        return !$el.selectedAmenities.find(function (elem) {
          return elem.name === amen.name;
        });
      });
    }
  },

  methods: {
    closeModal: function closeModal() {
      this.$children[0].$data.showModal = false;
    },

    removeAmenity: function removeAmenity(index) {
      this.selectedAmenities.splice(index, 1);
    },
    addAmenity: function addAmenity(index) {
      this.selectedAmenities.push({
        name: this.filteredAmenities[index].name,
        id: this.filteredAmenities[index].id
      });
    },
    getDropDownOptions: function getDropDownOptions() {
      var _this2 = this;

      this.loading = true;
      var $el = this;
      if (this.property) {
        axios.post("/prototype/units/options", { property: this.property }).then(function (response) {
          if (response.data) {
            $el.amenities = response.data.amenities;
            $el.unitTypes = response.data.unitTypes;
            $el.buildings = response.data.buildings;
            $el.statuses = response.data.statuses;
            $el.loading = false;
          } else {
            _this2.loading = true;
          }
        });
      }
    },
    close: function close() {
      Event.$emit("close-full-modal");
    },
    save: function save() {
      var _this3 = this;

      var $el = this;
      this.loading = true;
      if (!this.unit.building_id) {
        this.unit.building_id = this.building.id;
      }
      this.unit.unit_type_id = this.unitType.id;
      this.unit.verified_by = this.verified_by.id;
      this.unit.status = this.selectedStatus;
      axios.post("/prototype/units/", {
        unit: this.unit,
        amenities: this.selectedAmenities
      }).then(function (response) {
        if (response.data) {
          $el.loading = false;
          _this3.selectedAmenities = [];
          _this3.unitType = "";
          _this3.building = "";
          _this3.unit = {};
          Event.$emit("unit-added");
          $el.$children[0].$data.showModal = false;
        } else {
          _this3.loading = false;
        }
      });
    }
  },
  watch: {
    selectedStatus: function selectedStatus() {
      var $el = this;
      if ($el.selectedStatus == 'Vacant - Leased') {
        $el.move_in_date_display = true;
      } else {
        $el.move_in_date_display = false;
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/unit/AddUnit.vue
// module id = A0/q
// module chunks = 0 1